import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import XHR from 'i18next-xhr-backend';

import translationEn from './locales/lt/translation.json';

i18n
  .use(XHR)
  .use(LanguageDetector)
  .init({
    debug: false,
    lng: 'lt',
    fallbackLng: 'lt',

    keySeparator: false,
    interpolation: {
      escapeValue: false,
    },

    resources: {
      lt: {
        translations: translationEn,
      },
    },
    ns: ['translations'],
    defaultNS: 'translations',
  });

export default i18n;
